import axios from "axios";
import { getSessionData, removeSessionData } from "../../../utils/storageUtils";

// Função para determinar dinamicamente a URL da API
const determinarBaseURL = () => {
  // Use o valor do .env como padrão
  let url = process.env.REACT_APP_API_BASE_URL;
  
  // Se estamos em ambiente de produção e com hostname específico
  const hostname = window.location.hostname;
  
  // Se estamos no TS com IP público
  if (hostname === "200.194.172.7") {
    return "http://200.194.172.7:8062";
  }
  
  // Se estamos no TS com IP privado
  if (hostname === "10.61.20.1") {
    return "http://10.61.20.1:8062";
  }
  
  // Se estamos em localhost, podemos redirecionar para localhost
  if (hostname === "localhost") {
    return "http://localhost:8062";
  }
  
  return url;
};

const baseURL = determinarBaseURL();

const endpointPrincipal = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Adicionar interceptor para incluir o token em todas as requisições
endpointPrincipal.interceptors.request.use((config) => {
  const token = getSessionData("xc-helpdesk-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Adicionar interceptor para tratar erros de autenticação
endpointPrincipal.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido ou expirado
      removeSessionData("xc-helpdesk-token");
      removeSessionData("DadosUsuario");
      removeSessionData("EmailUsuario");
      removeSessionData("DadosUsuarioID");
      removeSessionData("PerfilUsuario");
      removeSessionData("isPerfilSuper");
      removeSessionData("NomeUsuario");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export { endpointPrincipal };
